import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Grid, Dimmer, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { isNil } from 'lodash';
import Header from './components/Header';
import { getActiveProject, invalidateActiveProject } from './data/projectActions';
import ExperimentalDesign from './containers/ExperimentalDesign';
import BasicInformation from './containers/BasicInformation';
import FileImport from './containers/FileImport';
import Booking from './containers/Booking';
import LockedProjectRoute from '../../../../components/LockedProjectRoute';

class SingleProject extends Component {
  componentDidMount() {
    this.props.dispatch(getActiveProject(this.props.match.params.id));
  }

  componentWillUnmount() {
    this.props.dispatch(invalidateActiveProject());
  }

  render() {
    const isDimmed = isNil(this.props.project);

    return (
      <Dimmer.Dimmable>
        <Dimmer active={isDimmed} inverted>
          <Loader size="huge">Loading</Loader>
        </Dimmer>
        <Grid centered>
          <Grid.Row>
            <Grid.Column width={15}>
              <Header project={this.props.project} section={this.props.activeProjectSection} />
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={15}>
              <Switch>
                <Route path={`${this.props.match.path}`} exact component={BasicInformation} />
                <Route
                  path={`${this.props.match.path}/experimental-design`}
                  exact
                  component={ExperimentalDesign}
                />
                <LockedProjectRoute
                  hasToBeLocked
                  path={`${this.props.match.path}/file-import`}
                  exact
                  component={FileImport}
                />
                <LockedProjectRoute
                  hasToBeLocked
                  path={`${this.props.match.path}/booking`}
                  exact
                  component={Booking}
                />
              </Switch>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Dimmer.Dimmable>
    );
  }
}

export default withRouter(
  connect(state => ({
    project: state.projects.single.active,
    activeProjectSection: state.projects.single.section
  }))(SingleProject)
);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/index.js